<a *ngIf='this.route.name != "Pseudocode"' class="item" [class.collapsed]="this.collapsed" [routerLink]="[this.route.route]" [routerLinkActive]="['active']">
    <mat-icon class="icon" [svgIcon]="this.route.name"></mat-icon>
    <p *ngIf="!this.collapsed">{{this.route.name}}</p>
</a>

<div *ngIf='this.route.name == "Pseudocode"' class="item" [class.collapsed]="this.collapsed" (click)="this.goToPage()">
    <mat-icon class="icon" [svgIcon]="this.route.name"></mat-icon>
    <p *ngIf="!this.collapsed">{{this.route.name}}</p>
</div>
